export default __webpack_public_path__ + "static/media/pg-37.28151025.jpg";